module.exports = __webpack_public_path__ + "assets/international.256537bf.svg";